const mittagessen_speisen = [
	{
		id: 5,
		title: "Vital-Wrap - herzhaft",
		description:
			"Lecker gegrillter Weizentortilla, bunt gefüllt - jeden Tag frisch. Komm an die Theke und such´ dir was raus! Dazu gibt´s natürlich unsere hausgemachten Dips!",
		price: "7.30",
	},
	{
		id: 6,
		title: "Vital-Wrap - süß",
		description:
			"Lecker gegrillter Weizentortilla, gefüllt mit Nutella und Banane - was will man mehr?",
		price: "5.30",
	},
	{
		id: 7,
		title: "Salate vom Buffet",
		description:
			"Komm an die Salatbar und bedien´ dich! Es erwarten dich täglich wechselnde bunte, kreative Salate!",
		price: "2.80 pro 100g - ",
	},
	{
		id: 4,
		title: "Hausgemachte Suppen",
		description: "Frag´ einfach nach unserem Tagesangebot",
		price: "klein 4.80",
		alt_one: "mittel 6.80",
		alt_two: "groß 8.80",
	},
];

export default mittagessen_speisen;
